import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const NewPageTemplateOption = (props) => {
  const { data } = props;

  if (data.type === 'files_archived' || data.type === 'collections_archived') {
    return null;
  }

  return (
    <components.Option {...props}>
      <div className="page-template-option">
        <div className="page-template-option-img">
          {data.thumbnail_url && (
            <img
              src={data.thumbnail_url}
              alt={data.name}
            />
          )}
        </div>
        <div className="page-template-option-meta">
          <span className="page-template-option-name">
            {data.name}
          </span>
          <span className="page-template-option-description">
            {data.description}
          </span>
        </div>
      </div>
    </components.Option>
  );
};

NewPageTemplateOption.propTypes = {
  data: PropTypes.object.isRequired,
  innerProps: PropTypes.object.isRequired,
};

export default NewPageTemplateOption;
